"use client";

import { cn } from "@/lib/utils";
import { motion } from "framer-motion";
import Image from "next/image";

interface LogoProps {
  className?: string;
  size?: "sm" | "md" | "lg";
}

const sizes = {
  sm: { width: 56, height: 70 },
  md: { width: 64, height: 80 },
  lg: { width: 72, height: 90 },
};

export function Logo({ className, size = "md" }: LogoProps) {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className={cn(
        "relative rounded-[20px] p-px text-white backdrop-blur-xl",
        "min-w-[280px]",
        className
      )}
    >
      <div className="relative flex items-center gap-4 z-10 rounded-[20px] py-2 px-4">
        <motion.div
          initial={{ opacity: 0, x: -10 }}
          animate={{ opacity: 1, x: 0 }}
          className="flex items-center"
        >
          <Image
            src="/logo/Panoptic Logo-zoom-W.svg"
            alt="Panoptic IT Solutions"
            width={280}
            height={70}
            className="text-white filter drop-shadow-[0_0_5px_rgba(255,255,255,0.5)]"
          />
        </motion.div>
      </div>
    </motion.div>
  );
}
